'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Client = require('./Client');

var _Client2 = _interopRequireDefault(_Client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Client: _Client2.default
};
module.exports = exports['default'];